import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { DvDividerComponent, DvTooltipDirective } from '@devinco/ui/dds';
import { RouteNetworkMaintainerIconName } from '@features/map/constants/constants';
import LayerColorUtils from '@features/map/utils/layer-color.utils';
import { TranslatePipe } from '@ngx-translate/core';
import { TimeAgoService } from '@shared/services/time-ago.service';

@Component({
  selector: 'app-route-status',
  imports: [TranslatePipe, DvDividerComponent, DvTooltipDirective],
  templateUrl: './route-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './route-status.component.scss',
})
export class RouteStatusComponent {
  private timeAgoService = inject(TimeAgoService);

  lastGroomedTime = input<string>();
  length = input<number>();
  customerId = input<number>();
  maintainerTypeId = input<number | null>();
  maintainerTypeTranslationKey = input<string | null>();

  machineIconUrl = computed(() => {
    const maintainerTypeId = this.maintainerTypeId();
    const iconName = maintainerTypeId
      ? RouteNetworkMaintainerIconName[maintainerTypeId]
      : undefined;
    return iconName ? `./assets/machine-icons/${iconName}.svg` : undefined;
  });

  lastGroomedTimeText = computed(() => {
    const lastGroomedTime = this.lastGroomedTime();
    return this.timeAgoService.timeAgo(lastGroomedTime);
  });

  statusIconUrl = computed(() => {
    const lastGroomedTime = this.lastGroomedTime();
    return LayerColorUtils.getRouteColorOrIcon(lastGroomedTime, this.customerId(), true);
  });
}
